var borders = {
  widths: {
    s: '1px',
    m: '2px',
    l: '4px'
  }
};
export default borders;